<template>
  <div class="ui-kit-v2-tag-iterator">
    <Button
      variant="add"
      size="xs"
      padding="m"
      icon-left="ui-plus-circle"
      class="ui-kit-v2-tag-iterator__item"
      @click="addEmptyTag"
    >
      {{ button }}
    </Button>
    <Tag
      v-for="(tag, index) in tagsClone"
      :key="'tag-' + index"
      class="ui-kit-v2-tag-iterator__item ui-kit-v2-tag-iterator__item--tag"
      :value="tag"
      :index="index"
      @save="saveTag(index, tag)"
      @delete="deleteTag(index, tag.id)"
      @input="input({ index, value: $event })"
    />
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import { tags } from '@/net';
import Tag from '@/components/UiKit/v2/Tag';
import Button from '@/components/UiKit/v2/Button';

export default {
  name: 'TagIterator',
  components: {
    Tag,
    Button
  },
  props: {
    tags: {
      type: Array,
      default: () => []
    },
    button: {
      type: String,
      default: 'Добавить тег'
    }
  },
  data() {
    return {
      tagsClone: []
    };
  },
  watch: {
    tagsClone: {
      deep: true,
      handler() {
        this.$emit('setTags', this.tagsClone);
      }
    }
  },
  mounted() {
    this.tagsClone = cloneDeep(this.tags);
  },
  methods: {
    addEmptyTag() {
      const newTag = {
        name: ''
      };
      this.tagsClone.unshift(newTag);
    },
    async deleteTag(index) {
      this.tagsClone.splice(index, 1);
    },
    async saveTag(index, tag) {
      const result = await tags.postTag(tag);
      if (result) {
        this.tagsClone[index].id = result.id;
        this.$emit('setTags', this.tagsClone);
      }
    },
    input(params) {
      this.tagsClone[params.index].name = params.value;
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'src/style/utils';

.ui-kit-v2-tag-iterator {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-right: 12px;

  &__item {
    margin-bottom: 12px;

    &::v-deep.ui-kit-v2-button {
      background-color: #f7f8fc;
      color: $ui-light-grey-4-5-contrast;
      min-width: unset;

      &:hover:not([disabled]) {
        background-color: #f7f8fc;
      }
    }

    &:not(:last-child) {
      margin-right: 12px;
    }

    &--tag {
      display: flex;
      align-items: center;
      padding: 0 12px;
    }
  }
}
</style>
